import { useRef as r, useDebugValue as n } from "react";

var useMultiRef = function useMultiRef() {
  var t = r([]);
  return n(t), [t, function (r) {
    return function (n) {
      t.current[r] = n;
    };
  }, function () {
    t.current = [];
  }];
};

export default useMultiRef;